import { render, staticRenderFns } from "./NumberBadge.vue?vue&type=template&id=eb2604d8&scoped=true&"
import script from "./NumberBadge.vue?vue&type=script&lang=js&"
export * from "./NumberBadge.vue?vue&type=script&lang=js&"
import style0 from "./NumberBadge.vue?vue&type=style&index=0&id=eb2604d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2604d8",
  null
  
)

export default component.exports